module.exports = __webpack_public_path__ + "media/notification.a0087893.mp3";